export default __webpack_public_path__ + "static/media/53238701b5847d826b8912c9dc07d852.svg";